import React, { useState } from 'react';

import { makeStyles } from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';
import Typography from '@material-ui/core/Typography';

import { omit } from '../../app/common/useful';
import { Alert } from '@material-ui/lab';
import Button from '@material-ui/core/Button'

const useStyles = makeStyles((theme) => ({
    root: {
        width: '100%',
        backgroundColor: theme.palette.background.paper,
    },

}));

const validCountries = [/england/i, /wales/i, /scotland/i];

const SolicitorList = ({ data, onSelect }) => {
    const classes = useStyles();
    const [highlight, setHighlight] = useState();

    const handleListItemClick = (office) => {
        onSelect({ office, firm: firms.get(office.OfficeId) });
    };

    const offices = [];
    const firms = new Map();

    data?.forEach(org => {
        org.Offices.forEach(office => {
            // we don't need the offices array as we'll be passing the firm & office back as two objects
            firms.set(office.OfficeId, omit('Offices', org));
            if (validCountries.find(rx => rx.test(office.Country))) {
                offices.push(office);
            }
        })
    });

    if (data && offices.length === 0) return <Alert severity="info" variant="standard" style={{ marginTop: '1rem' }}>No matching firms found</Alert>

    return (
        <div className={classes.root}>
            {
                offices.map(office => {
                    var address = office.Address1 ?? '';
                    if (office.Town) {
                        address += `, ${office.Town}`
                    }

                    return (
                        <Paper key={office.OfficeId}
                            style={{ padding: '1rem', marginTop: '0.5rem' }}
                            onClick={() => handleListItemClick(office)}
                            onMouseEnter={() => setHighlight(office.OfficeId)}
                            onMouseLeave={() => setHighlight(undefined)}
                            className="selectable"
                        >
                            <Typography variant="button" color="initial">{office.Name}</Typography>
                            <Typography variant="subtitle2" color="textSecondary">{address}</Typography>
                            <Typography variant="subtitle2" color="textSecondary">{office.PhoneNumber?.slice(0, 5)} {office.PhoneNumber?.slice(5)}</Typography>
                            <Typography variant="subtitle2" color="textSecondary">{office.Website}</Typography>
                            {
                                highlight === office.OfficeId &&
                                <Button onClick={() => handleListItemClick(office)} variant="contained" color="secondary" style={{ marginTop: '1rem' }}>Use this firm</Button>
                            }
                        </Paper>
                    );
                })
            }
        </div>
    );
}

export default SolicitorList;